import React from 'react'

/**
 * Форматирует текст расчёта L3:
 * - Формула / Formula — выделенный блок сверху
 * - Вклады / Contributions — заголовок секции
 * - Строки с → — левая часть синяя, правая зелёная/красная для +/−
 */
export default function L3CalcText({ text }) {
  if (!text) return null

  const lines = text.split('\n')
  const formulaEnd = lines.findIndex((l) => l.startsWith('Вклады') || l.startsWith('Contributions') || l.startsWith('Дельты') || l.startsWith('Blend'))
  const hasFormulaBlock = formulaEnd > 0

  return (
    <div className="l3-calc-text">
      {hasFormulaBlock && (
        <div className="l3-calc-formula-block">
          {lines.slice(0, formulaEnd).map((line, i) => (
            <div key={i} className="l3-calc-formula-line">{line}</div>
          ))}
        </div>
      )}
      <div className="l3-calc-details">
        {(hasFormulaBlock ? lines.slice(formulaEnd) : lines).map((line, i) => {
          const isSectionHeader = /^(Вклады|Contributions|Дельты|Blend\s)/.test(line.trim())
          if (isSectionHeader) {
            return <div key={i} className="l3-calc-section-header">{line}</div>
          }

          const arrowIdx = line.indexOf(' → ')
          if (arrowIdx === -1) {
            return <div key={i} className="l3-calc-line">{line}</div>
          }

          const left = line.slice(0, arrowIdx)
          const right = line.slice(arrowIdx + 3)
          const trimmedRight = right.trim()
          const isPos = /^\+/.test(trimmedRight)
          const isNeg = /^[−\-]\d/.test(trimmedRight) || /^−/.test(trimmedRight)

          return (
            <div key={i} className="l3-calc-line l3-calc-line-arrow">
              <span className="l3-calc-input">{left}</span>
              {' → '}
              {isPos && <span className="l3-calc-pos">{right}</span>}
              {isNeg && <span className="l3-calc-neg">{right}</span>}
              {!isPos && !isNeg && <span>{right}</span>}
            </div>
          )
        })}
      </div>
    </div>
  )
}
